import * as React from 'react'
import { useMap } from 'react-leaflet'

const MapResizeHandler: React.FC = () => {
    const map = useMap()

    React.useEffect(() => {
        const observer = new ResizeObserver(() => map.invalidateSize())

        observer.observe(map.getContainer())

        return () => observer.disconnect()
    }, [map])

    return null
}

export default MapResizeHandler
